/**
 * Vuetify 4 instance (ADR-012). Components are auto-imported by vite-plugin-vuetify,
 * icons are tree-shaken SVG paths from @mdi/js, and the component defaults below are
 * the design system: every screen inherits them instead of restating them.
 */
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'

import { dark, light } from '@/app/ui/theme'

export const vuetify = createVuetify({
  theme: {
    defaultTheme: 'system',
    themes: { light, dark },
    variations: false,
  },
  icons: { defaultSet: 'mdi', aliases, sets: { mdi } },
  defaults: {
    global: { ripple: false },
    VBtn: { rounded: 'lg', variant: 'flat', class: 'text-none font-weight-medium' },
    VCard: { rounded: 'xl', variant: 'flat', border: true },
    VSheet: { rounded: 'xl' },
    VTextField: { variant: 'outlined', density: 'comfortable', rounded: 'lg', color: 'primary' },
    VTextarea: { variant: 'outlined', density: 'comfortable', rounded: 'lg', color: 'primary' },
    VSelect: { variant: 'outlined', density: 'comfortable', rounded: 'lg', color: 'primary' },
    VAutocomplete: { variant: 'outlined', density: 'comfortable', rounded: 'lg', color: 'primary' },
    VCombobox: { variant: 'outlined', density: 'comfortable', rounded: 'lg', color: 'primary' },
    VNumberInput: { variant: 'outlined', density: 'comfortable', rounded: 'lg', color: 'primary' },
    VOtpInput: { variant: 'outlined', rounded: 'lg' },
    VSwitch: { color: 'primary', inset: true, density: 'comfortable' },
    VCheckbox: { color: 'primary', density: 'comfortable' },
    VChip: { label: true, size: 'small', rounded: 'lg' },
    VAlert: { variant: 'tonal', rounded: 'lg', density: 'comfortable' },
    VDialog: { maxWidth: 520, scrim: 'rgba(11, 13, 26, 0.55)' },
    VMenu: { offset: 6 },
    VList: { density: 'compact', nav: true },
    // UX review §2.2: below md a table stacks each row as a labelled card instead of
    // scrolling sideways; the pagination footer disappears when one page holds everything.
    VDataTable: { hover: true, density: 'comfortable', mobileBreakpoint: 'md' },
    VDataTableServer: { hover: true, density: 'comfortable', mobileBreakpoint: 'md' },
    VTooltip: { location: 'top' },
    VSkeletonLoader: { color: 'transparent' },
    VProgressLinear: { color: 'accent', rounded: true },
    VTab: { class: 'text-none' },
    VSnackbar: { rounded: 'lg', timeout: 5000, location: 'bottom right' },
  },
})
